import { AspectRatioContainer, Container, Image, ThemeProvider } from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';
import { IMAGE_DEFAULT_VWLOGO } from '../../../../app';
import { NormalizedVoucher } from '@esportal/portal-service';
import { COLOR_TOKEN } from '../../../../helpers/color-tokens';
import { VouchersDescription } from './vouchers-description';

const VouchersCardContainer = styled.div`
	height: 100%;
	position: relative;
	backdrop-filter: blur(10px);
	border-radius: 16px;
	background: ${COLOR_TOKEN.background.tertiary};

	/* Shadow04 */
	box-shadow: none;
`;

export const VouchersCard: React.FC<{
	voucher: NormalizedVoucher;
	shouldDisplayGetButton: boolean;
	handleClickVoucher: () => void;
	showButton?: boolean;
}> = ({ voucher, shouldDisplayGetButton, handleClickVoucher, showButton = true }) => {
	return (
		<ThemeProvider>
			<VouchersCardContainer className="vouchers-card-container" onClick={handleClickVoucher}>
				<Container horizontalAlign={'center'} wrap="always">
					<AspectRatioContainer ratio="3:2">
						<Image
							src={voucher.card.imageUrl || IMAGE_DEFAULT_VWLOGO}
							objectFit="cover"
							alt="Voucher_image"
							style={{
								borderTopLeftRadius: '16px',
								borderTopRightRadius: '16px',
								borderBottomLeftRadius: '16px',
								borderBottomRightRadius: '16px',
							}}
						/>
					</AspectRatioContainer>

					<VouchersDescription
						voucher={voucher}
						shouldDisplayGetButton={shouldDisplayGetButton}
						showButton={showButton}
					/>
				</Container>
			</VouchersCardContainer>
		</ThemeProvider>
	);
};
